import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Modal from '../../../shared/ui/Modal';
import tagsActions from '../../store/tags/action-creators';
import tagsSelectors from '../../store/tags/selectors';
import AddActionButton from '../common/AddActionButton';
import TagAdd from './TagAdd';
import TagEdit from './TagEdit';
import TagTable from './TagTable';

class TagsIndex extends Component {
  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    this.props.loadTagsIndex();
  }

  // ----------------------
  // Computed
  // ----------------------

  get isLoading() {
    return !this.props.tags;
  }

  // ----------------------
  // Methods
  // ----------------------

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        {!this.isLoading && (
          <Fragment>
            <div className="app-content-header">
              <h4 className="title">Tags</h4>
              <AddActionButton label="Tag" onAdd={this.props.addTag} />
            </div>
            <div className="app-content">
              <TagTable onEdit={this.props.editTag} tags={this.props.tags} />
            </div>
          </Fragment>
        )}
        <Modal
          isOpen={this.props.isAddingTag}
          title="Create Tag"
          onClose={this.props.closeAddTag}
        >
          <TagAdd />
        </Modal>
        <Modal
          isOpen={this.props.isEditingTag}
          title="Edit Tag"
          onClose={this.props.closeEditTag}
        >
          <TagEdit tag={this.props.editingTag} />
        </Modal>
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    editingTag: tagsSelectors.editingTag(state),
    isAddingTag: state.tags.isAddingTag,
    isEditingTag: !!state.tags.isEditingTag,
    tags: state.tags.list,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addTag: () => {
      dispatch(tagsActions.addTag());
    },
    closeAddTag: () => {
      dispatch(tagsActions.closeAddTag());
    },
    closeEditTag: () => {
      dispatch(tagsActions.closeEditTag());
    },
    editTag: (tagGuid) => {
      dispatch(tagsActions.editTag(tagGuid));
    },
    loadTagsIndex: () => {
      dispatch(tagsActions.loadTagsIndex());
    },
    setSelectedGuid: (tagGuid) => {
      dispatch(tagsActions.setSelectedGuid(tagGuid));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TagsIndex);
